<template>
  <v-row justify="start" align="center" style="max-width: 600px; margin: 0 auto; height:60px; ">
      <v-col class="pt-0 mb-0 pb-0 mt-0 px-0">
        <v-row style="max-width: 600px; margin: 0 auto; position: relative">
          <v-col cols="8" justify="start" align="start" style="height: 60px;" :style="{ 'background-color': $store.state.colors.primary }" class="pt-0 mt-0" >
            <v-row justify="start" align="center" style="height: 60px;" class="pt-0 pl-2">
              <!-- <object oa-reusable-svg
                      :data="require('@/assets/resources/logos_white/' + this.$store.state.codigo_marca + '.svg')"
                      type="image/svg+xml"
                      class="svg-class"
                      height="55"
                      width="55">
              </object> -->
              <img v-if="!$store.state.validationDelivery" style="max-height:55px;" :src="$store.state.logoSRC" />
              <img v-else style="max-height:55px;" :src="require('@/assets/resources/yoomi/yoomy-blanco.png')" />
              <!-- <img class='icon' :src="$store.state.logoSRC" style="max-height:55px;"> -->
            </v-row>
          </v-col>
          <v-col cols="4" style="height: 60px;" class="pt-0 mt-0" :style="{ 'background-color': $store.state.colors.primary }">
            <v-row justify="end" align="center" class="mr-1 py-0 my-0" style="height: 60px; float: right;">
              <v-btn v-if="$store.state.validationDelivery==false" @click="$store.state.activeDialogOrders = true" icon color="grey">
                <div class="container my-0 py-0">
                  <img class='icon' src="@/assets/resources/icons/icon_notifications.png" style="max-height:40px;">
                  <div v-if="this.$store.state.notifications_amount>0 && this.$store.state.notifications_amount<10" class="top-right RestoBold">{{ this.$store.state.notifications_amount }}</div>
                  <div v-if="this.$store.state.notifications_amount>9" class="top-right RestoBold">+9</div>
                </div>
              </v-btn>
                  <dialog-Orders></dialog-Orders>
              <v-btn v-if="$store.state.validationDelivery==false" icon color="grey" @click="drawer=!drawer">
                <img class='icon' src="@/assets/resources/icons/icon_menu.png" style="max-height:40px;">
              </v-btn>
              <v-btn v-if="$store.state.validationDelivery==true" icon color="white" @click="dialogDM=true" class="mr-4 buttonLower">
                <img class='icon' src="@/assets/resources/icons/icon_profile.png" style="max-height:20px;">Salir
              </v-btn>
            </v-row>
          </v-col>
          <v-row style="width: 100%; position:absolute; top: 60px; left: 12px;" :style=" { 'height': containerHeight + 'px' }" v-if="drawer">
            <v-navigation-drawer
                v-model='drawer'
                :temporary="true"
                :color="color"
                :right="right"
                style="height: 100%"
                absolute
            >
                <v-list
                dense
                nav
                class="py-0"
                style="border-radius: 0px; width: 100%; margin: 0; padding: 0; height: 100%" :style="{ 'background-color': $store.state.colors.primary }"
                >

                    <v-list-item
                        v-for="item in items"
                        :key="item.title"
                        style="border-radius: 0px;  margin: 0px;"
                        :style="{ backgroundColor: item.color }" 
                        link
                        @click="goTo(item.path)"
                    >
                    <div>
                        <img class='icon' :src="require('@/assets/resources/icons/' + item.icon + '.png')" style="width:40px; height:40px; vertical-align:middle; margin: 10px;"><span style="color: white;" class="RestoRegular">{{ item.title }}</span>
                    </div>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
        </v-row>
        </v-row>
    </v-col>
        <v-dialog
            v-model="dialog"
            max-width="290"
            persistent
        >
            <v-card>
                <v-card-title class="headline"><span>¿Deseas cerrar <br> sesión?</span></v-card-title>

                <v-card-text>
                Si decides cerrar sesión tu pedido actual se perderá permanentemente ¿Deseas continuar?
                </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="dialog=false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    No
                </v-btn>

                <v-btn @click="exit();" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Sí
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- DM Exit Card -->
        <v-dialog
            v-model="dialogDM"
            max-width="290"
            persistent
        >
            <v-card>
                <v-card-title class="headline"><span>¿Deseas cerrar <br> sesión?</span></v-card-title>

                <!-- <v-card-text>
                Si decides cerrar sesión tu pedido actual se perderá permanentemente ¿Deseas continuar?
                </v-card-text> -->

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="dialogDM=false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    No
                </v-btn>

                <v-btn @click="exitDM();" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Sí
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </v-row>
</template>

<script>
import dialogOrders from '@/components/notificationsOrders'
  
  export default {
    components:
    {
      'dialog-Orders': dialogOrders
    },
    data () {
      return {
        dialogOrders: false,
        drawer: false,
        items: [
          { title: 'Mi pedido', icon: "icon_ticket", color: this.$store.state.colors.secondary, path: "order"},
          { title: 'Historial de pedidos', icon: "icon_ticket", color: this.$store.state.colors.primary, path: "history"},
          { title: 'Editar mi perfil', icon: 'icon_profile', color: this.$store.state.colors.primary, path: "userprofile" },
          // { title: 'Seleccionar envío', icon: 'icon_location_white', color: this.$store.state.colors.primary, path:"select_delivery" },
          { title: 'Salir', icon: 'icon_profile', color: this.$store.state.colors.primary, path:"verification" }
        ],
        color: this.$store.state.colors.primary,
        right: true,
        dialog: false,
        dialogDM: false,
        windowSize: {
          x: 0,
          y: 0,
      },
      containerHeight: null,
      }
    },
    mounted () {     
      var that = this;
      function resize()
            {
                var heights = window.innerHeight - 60;
                that.containerHeight = heights;
                // console.log(that.containerHeight);
                // document.getElementById("menu").style.height = heights - 60 + "px";
            }
            resize();
            window.onresize = function() {
                resize();
            };
    },
    methods: {
        getImage(path) {
            // console.log("EL PATH: ",path);
            return require(path)
        },
        onResize () {
                this.windowSize = { x: window.innerWidth, y: window.innerHeight }
                this.containerHeight = this.windowSize.y - 60;
                // console.log(this.containerHeight)
            },
        exit() {
          this.dialog=false;
          this.$store.state.lista_platillos = []; 

          localStorage.removeItem('original_id_sucursal'); 
          localStorage.removeItem('sucursalData'); 
          localStorage.removeItem('comentarios'); 
          localStorage.removeItem('metodo_envio'); 
          localStorage.removeItem('Servicio'); 
          localStorage.removeItem('propina'); 
          localStorage.removeItem('propinasBandera'); 
          localStorage.removeItem('formas_aceptadas'); 
          this.$store.dispatch('initilizePedido')
          localStorage.removeItem('userCards'); 
          this.$store.state.validationDelivery=false;
          localStorage.removeItem('token'); 
          this.$store.state.token = null; 
          this.$store.state.logo = false;
          localStorage.removeItem('id_cliente'); 
          this.$store.state.id_cliente = null; 
          localStorage.removeItem('id_sucursal'); 
          this.$store.state.id_sucursal = null; 
          localStorage.removeItem('nombre_cliente'); 
          localStorage.removeItem('addressUser');
          this.$store.state.nombre_cliente = null; 
          this.$router.push({ name: 'logo'});
          localStorage.removeItem('tokenDM'); 
          this.$store.state.tokenDM = null; 
        },
        exitDM() {
          console.log("Exit DM")
          localStorage.removeItem('tokenDM'); 
          this.$store.state.tokenDM = null; 
          localStorage.removeItem('id_repartidor'); 
          localStorage.removeItem('id_sucursal');
          this.$store.state.id_sucursal = null; 
          // this.$router.push({ name: 'loginDeliveryMan'});
          location.reload();
          this.dialogDM=false;
          this.$store.state.validationDelivery=false;
          this.$store.state.logo = false;
          
        },
        goTo(view_name) {
          var names = 'userDetails';
          // console.log(view_name);
          if(view_name == "verification")
          {
            // this.exit();
            this.dialog=true;
          }
          else
          {
            if(view_name == 'history')
            {
              view_name = 'userprofile';
              names = 'history';
              this.$router.push({ name: view_name, params: {name: names} });
            }
            else
              this.$router.push({ name: view_name});
            
          }
        }
    },
  }
</script>

<style scoped>
    .btn-color-border{
        border-color: #39b54a !important;
    }
    .svg-class > svg {
      fill: red !important; 
    }
    .container {
      position: relative;
      text-align: center;
      color: white;
    }
    .top-right {
      position: absolute;
      top: 8px;
      right: 16px;
      font-size: 15px;
      border-radius: 50px 50px 50px 5px;
      color: white;
      background-color: red;
    }
</style>